import BigNumber from 'bignumber.js';

export type Numerable = number | string | BigNumber;

export const toBN = (origVal: Numerable, dividerDecimals = 0): BigNumber | undefined => {
  const val = origVal;
  if (Number.isNaN(Number(val))) {
    return new BigNumber(val);
  }
  // eslint-disable-next-line no-nested-ternary
  return val instanceof BigNumber
    ? dividerDecimals !== undefined
      ? val.div(new BigNumber(10).pow(dividerDecimals))
      : val
    : new BigNumber(val.toString()).div(new BigNumber(10).pow(dividerDecimals));
};
export const formatBN = (val: Numerable, precision: Numerable = 2, dividerDecimals = undefined) => {
  return toBN(val, dividerDecimals)
    .decimalPlaces(Number(precision), BigNumber.ROUND_HALF_DOWN)
    .toString();
};

export const applyDecimals = (val: Numerable, decimals: number): BigNumber =>
  toBN(val).times(new BigNumber(10).pow(decimals));

export const removeDecimals = (val: Numerable, decimals: number): BigNumber => toBN(val, decimals);

export function isAddressesEqual(address0: string, address1: string): boolean {
  if (!address0 || !address1) return false;
  return address0.toLowerCase() === address1.toLowerCase();
}

export const arrayFromN = (N: number) =>
  N > 0 ? new Array(N).fill(0).map((_, index) => index) : [];

export const formatBNWithCommas = (
  val: Numerable,
  precision: Numerable = 2,
  dividerDecimals = undefined,
  lessSign = false,
) => {
  if (val === null || val === undefined) {
    return 'NaN';
  }
  if (Number.isNaN(Number(val))) {
    return 'NaN';
  }
  const numPrecision = Number(precision);
  const numVal = Number(toBN(val, dividerDecimals));

  const targetMinValue = 1 / 10 ** numPrecision;
  if (lessSign && numVal < targetMinValue && Number(val) > 0) {
    return `<0.${arrayFromN(numPrecision - 1)
      .map(() => '0')
      .join('')}1`;
  } if (lessSign && numVal < targetMinValue && Number(val) < 0) {
    return `>-0.${arrayFromN(numPrecision - 1)
      .map(() => '0')
      .join('')}1`;
  }

  return numVal.toLocaleString('en-US', {
    maximumFractionDigits: numPrecision,
    minimumFractionDigits: numPrecision,
  });
};


